/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const CreateBlueSkyFilingInputJsonApiModel = {
  id: "",
  "blue-sky-filing": {
    jsonApi: "hasOne",
    type: "blue-sky-filings",
  },
};
